import type { PageHelp } from "../../help/types";

export const homeHelp: PageHelp = {
  title: "Start page",
  intro:
    "The first page you see after signing in. Your employer uses it to welcome you to its benefit programme; from here, “Get started” takes you to your first task.",
  sections: ["Welcome"],
  tips: [
    "Until you have given your consent on the Profile page, only the start page and your profile are available — the other pages and the AI assistant stay greyed out. Giving consent unlocks them.",
    "Linked to more than one employer? Each one has its own start page, benefits and documents; switch between them in the side navigation (on a phone: your picture at the top right, then the employer name).",
  ],
  steps: [
    {
      selector: '[data-help="home-welcome"]',
      title: "Read your employer's welcome",
      body: "A message written by your employer about its benefit programme — what is offered, who to contact, important dates. The text and any pictures in it come from your employer, so they differ from one employer to the next.",
      section: "Welcome",
    },
    {
      selector: '[data-help="home-get-started"]',
      title: "Get started",
      body: "Takes you to the next step. If you have not yet given your consent, it opens your profile, where you give it; once consent is given, it opens the Benefits page with the packages your employer offers.",
      section: "Welcome",
    },
    {
      selector: '[data-help="home-picture"]',
      title: "Your employer's picture",
      body: "A picture chosen by your employer for its benefit programme; a standard picture is shown when your employer has not set one. It is for illustration only and has no action.",
      section: "Welcome",
    },
  ],
};
